import { setFilter } from "../weightedPriceUXSlice";
import { setData } from "../weightedPriceDataSlice";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../../core/store/reducers";
import React from "react";
import { WeightedPricesReportFilter } from "../types";
import { useCopiedState } from "../../../../../core/util/hooks";

export const useWeightPriceReportFilter = () => {
  const storeFilter = useSelector<StoreType, WeightedPricesReportFilter>(
    (store) => store.ux.reports.exchbusiness.weightedPrice.filter
  );
  const [filter, editFilter] = useCopiedState<WeightedPricesReportFilter>(
    storeFilter
  );

  const dispatch = useDispatch();
  const dispatchSetFilter = React.useCallback(() => {
    dispatch(setFilter(filter!));
    dispatch(setData());
  }, [dispatch, filter]);

  return [filter, editFilter, dispatchSetFilter] as [
    typeof filter,
    typeof editFilter,
    typeof dispatchSetFilter
  ];
};
